import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
export var EMPTY_STATE_IMAGE = "staticfiles/images/empty_states/empty-state.png";
export var EMPTY_STATE_IMAGE_2x = "staticfiles/images/empty_states/empty-state@2x.png";
export var EMPTY_STATE_IMAGE_2144x1008 = "staticfiles/images/empty_states/empty-state-2144x1008.jpg";
export var UPLOAD_FILE_IMAGE = "staticfiles/images/upload-file-image.jpg";
export var FILE_UPLOAD_ICON = "staticfiles/images/upload-file-icon.svg";
export var getCloudFrontUrl = function getCloudFrontUrl(imagePath) {
  var _context2;
  var cloudFrontDomain = window.CLOUDFRONT_DOMAIN;
  if (cloudFrontDomain) {
    var _context;
    var domain = _startsWithInstanceProperty(cloudFrontDomain).call(cloudFrontDomain, "http") ? cloudFrontDomain : "https://".concat(cloudFrontDomain);
    return _concatInstanceProperty(_context = "".concat(domain, "/")).call(_context, imagePath.replace(/^\//, ""));
  }
  return _concatInstanceProperty(_context2 = "".concat(window.STATIC_URL)).call(_context2, imagePath);
};